import { CookieService } from 'ngx-cookie-service';
import { TranslateService } from '@ngx-translate/core';
import { IMovidaTranslateService } from './abstractions.service';
import { LoganLanguage } from '../models/commons.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoganTranslateService implements IMovidaTranslateService {
  public static readonly LANGUAGE_KEY: string = 'lang';
  public static readonly LANGUAGE_DEFAULT: string = 'pt';

  public locations: Map<string, LoganLanguage> = LoganLanguage.buildMap([
    {
      id: 1,
      name: 'Português',
      flag: 'assets/images/flags/brazil.jpg',
      language: 'pt',
    },
    {
      id: 2,
      name: 'English',
      flag: 'assets/images/flags/us.jpg',
      language: 'en',
    },
    {
      id: 3,
      name: 'Spanish',
      flag: 'assets/images/flags/spain.jpg',
      language: 'es',
    },
  ]);
  private _current: LoganLanguage | undefined;

  constructor(
    private cookieService: CookieService,
    public translate: TranslateService
  ) {
    this.translate.addLangs(this.languages);
    this.translate.setDefaultLang(LoganTranslateService.LANGUAGE_DEFAULT);

    let last = cookieService.check(LoganTranslateService.LANGUAGE_KEY)
      ? cookieService.get(LoganTranslateService.LANGUAGE_KEY)
      : translate.getBrowserLang();

    this.setLanguage(
      this.locations.has('pt') ? last : LoganTranslateService.LANGUAGE_DEFAULT
    );
  }

  /***
   * Cookie Language set
   */
  public setLanguage(lang: any) {
    if (this.locations.has(lang)) {
      this._current = this.locations.get(lang);

      this.translate.use(lang);
      this.cookieService.set(LoganTranslateService.LANGUAGE_KEY, lang);
    }
  }

  // Getters

  /**
   * Linguagem selecionada
   * @returns Código da linguagem selecionada
   */
  get language(): string {
    return this._current?.language!;
  }

  /**
   * Localização selecionada
   * @returns Objeto da localização selecionada
   */
  get location(): LoganLanguage {
    return this._current!;
  }

  /**
   * Lista dos códigos de linguagem disponíveis
   * @returns Código da linguagem selecionada
   */
  get languages(): Array<string> {
    return Array.from(this.locations.keys());
  }

  get allLanguages(): Array<LoganLanguage> {
    return Array.from(this.locations.values());
  }
}
